const NoPage = () => {
    return (
    <div className='nopage'>
       <h1>File Not Found: 404</h1>;
    </div>
    ) 
  }
  
  export default NoPage;